import { Link } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { DemoUIState } from '@/model/demo/types';
import { UIState } from '@/model/global/types';

export interface WalletPageLinkProps {}

const WalletPageLink: React.FC<WalletPageLinkProps> = () => (
  <Link variant="body1" key="wallet" component={RouterLink} to={`/${UIState.WITHDRAWAL}/${DemoUIState.WALLET}`}>
    <HomeIcon />
  </Link>
);

export default WalletPageLink;
